export default __webpack_public_path__ + "static/media/Haykal.8da60e2a.jpg";